import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
    * {
        box-sizing: border-box;
    };

    body {
        margin: 0;
    }

    /* css changes */
    ::-webkit-scrollbar {
        width: 4px;
        height: 4px;
    }

    ::-webkit-scrollbar-thumb {
        background-color: #dae1e7;
        border: solid 2px transparent;
        border-radius: 12px;
    }

    ::-webkit-scrollbar-track {
        border: solid 2px transparent;
    }

    ::-webkit-scrollbar-corner {
        background-color: transparent;
    }

    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
        transition: "color 9999s ease-out, background-color 9999s ease-out";
        transition-delay: 9999s;
    }

    /* ant-design global changes */
    .ant-form-item-label {
        font-weight: 400;
    }

    /* custom popover style for tool buttons */
    .tool-popover {
        .ant-popover-inner {
            padding: 0;
            border-radius: 10px;
            
            .ant-popover-title {
                padding: 20px 24px;
                margin-bottom: 0;
                border: 1px solid ${props => props.theme.layouts.mainLayout.header.notifications.dividerColor};
                border-radius: 10px 10px 0 0;
            }
        }
    }

    /* Note: Source https://github.com/ant-design/ant-design/issues/26758#issuecomment-1900366318 */

    .ant-picker-dropdown {
        .ant-picker-panel-container {
            @media (width <= 800px) {
                overflow: scroll !important;
                
                .ant-picker-panel-layout {
                    flex-direction: column !important;

                    .ant-picker-presets {
                        max-width: 100% !important;
                        min-height: 10rem !important;
                    }

                    .ant-picker-panels,
                    .ant-picker-datetime-panel {
                        flex-direction: column !important;
                    }
                }
            }
        }

        .ant-picker-body {
            padding: 20px 16px !important;
        }

        .ant-picker-content {
            height: 190px !important;
        }
        
        .ant-picker-date-panel {
            width: 300px;
        }

        .ant-picker-month-panel, .ant-picker-year-panel {
            width: 250px;
            
            .ant-picker-cell-inner{
                width: 65px;
            }
        }
        
        .ant-picker-cell{
            padding: 0 !important;
        }

        .ant-picker-cell-inner {
            width: 60%;
        }
    }
`;
